appExperimente.controller('TrialModalController', ['$rootScope', '$scope', '$uibModalInstance', 'vrModalCustomize', 'modalTitle', 'modalText', 'trialArea', function ($rootScope, $scope, $uibModalInstance, vrModalCustomize, modalTitle, modalText, trialArea) {

  $scope.modalTitle = modalTitle;
  $scope.modalText = modalText;
  $scope.trialArea = trialArea;

  $scope.close = function () {
    $uibModalInstance.dismiss("close");
  };

  $scope.tutorial = function () {
    $uibModalInstance.dismiss("close");
    $rootScope.$broadcast(constants.EVENTS.TUTORIAL_START);
  };

  vrModalCustomize.toCenter($uibModalInstance);

  if (constants.SETTINGS.DEBUG) {
    $scope.exposeScope('TrialModalController', $scope);
  }

}]);
